import type { DailyQuoteProps } from "@packages/ui";
import { IconButton, ShareIcon } from "@packages/ui";
import type { MouseEventHandler } from "react";

import type { BaseGetSectionItemProps } from "./Section.emotion";

export type GetSectionItemDailyQuotePropsProps = BaseGetSectionItemProps & {
  isKidAccount?: boolean;
  onShare: MouseEventHandler;
};

export const getSectionItemDailyQuoteProps = ({
  isKidAccount,
  item,
  onShare,
}: GetSectionItemDailyQuotePropsProps): DailyQuoteProps => ({
  attribution: item?.reference?.attributed_to,
  quote: item?.reference?.text,
  actions: isKidAccount
    ? []
    : [
        <IconButton
          key="daily-quote-share"
          icon={<ShareIcon />}
          variant={"secondary"}
          onClick={onShare}
        />,
      ],
});
